export enum SystemError {
    QUERY_PARAM_ERROR = 'QUERY_PARAM_ERROR',
    QUERY_PARAM_TOKEN_ERROR = 'QUERY_PARAM_TOKEN_ERROR',
}
